module.exports = __webpack_public_path__ + "static/img/mobile-phone-screen-disply.3fe8a11.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mobile-phone-screen-disply.png
// module id = 1139
// module chunks = 5